export default __webpack_public_path__ + "static/media/side_frame.8e07ee77.svg";